import { api } from '@/api/client';
import type { CredentialType } from '@/api/credentials';

export type AttributeType =
  | 'text'
  | 'textarea'
  | 'number'
  | 'url'
  | 'email'
  | 'date'
  | 'secret'
  | 'file';

export interface AttributeDef {
  key: string;
  label: string;
  type: AttributeType;
  required: boolean;
  secret: boolean;
  default?: string | null;
}

export interface CredentialTypeSchemaResponse {
  type: CredentialType;
  attributes: AttributeDef[];
  is_custom: boolean;
  updated_at: string | null;
}

export const credentialSchemasApi = {
  list: (tenantId: string) =>
    api.get<CredentialTypeSchemaResponse[]>(`/tenants/${tenantId}/credential-schemas`),

  get: (tenantId: string, type: CredentialType) =>
    api.get<CredentialTypeSchemaResponse>(
      `/tenants/${tenantId}/credential-schemas/${type}`,
    ),

  update: (tenantId: string, type: CredentialType, attributes: AttributeDef[]) =>
    api.put<CredentialTypeSchemaResponse>(
      `/tenants/${tenantId}/credential-schemas/${type}`,
      { attributes },
    ),

  reset: (tenantId: string, type: CredentialType) =>
    api.delete<null>(`/tenants/${tenantId}/credential-schemas/${type}`),
};

/** Returnează key-ul primului atribut marcat secret — folosit pentru
 *  Copy/Reveal rapid în VaultList (de obicei password / api_key / private_key). */
export function primarySecretKey(schema: CredentialTypeSchemaResponse | undefined): string | null {
  if (!schema) return null;
  const first = schema.attributes.find((a) => a.secret);
  return first?.key ?? null;
}
